import { inject, observer } from "mobx-react";
import React from "react";
import { TooltipComponent } from "@fidget/common/components/tooltipComponent";
import { L10n } from "@fidget/common/i18n";
import { ForeContext } from "../../context";
import { IForeCallStore } from "../../models/call/foreCallModel";
import styles from "./widgetCallControls.css";
import { WidgetControlCircle } from "./widgetControlCircle";

const TOOLTIP_WIDTH = 150;

interface Props {
  shouldCallDrawerBeHidden: boolean;
  foreCallStore?: IForeCallStore;
  foreContext: ForeContext;
}

@inject("foreCallStore")
@observer
export class WidgetCallControls extends React.Component<Props> {
  get injected(): { foreCallStore: IForeCallStore } {
    return this.props as { foreCallStore: IForeCallStore };
  }

  getCameraTooltipText(): JSX.Element {
    const textId = this.injected.foreCallStore.localCamera.enabled
      ? "widget.call.cameraTurnOff"
      : "widget.call.cameraTurnOn";
    return <L10n id={textId} />;
  }

  getMicTooltipText(): JSX.Element {
    const textId = this.injected.foreCallStore.localMicrophone.enabled
      ? "widget.call.mute"
      : "widget.call.unmute";
    return <L10n id={textId} />;
  }

  getVideoExpandTooltipText(): JSX.Element {
    const textId = this.injected.foreCallStore.videoExpanded
      ? "widget.call.minimise"
      : "widget.call.expand";
    return <L10n id={textId} />;
  }

  render() {
    const call = this.injected.foreCallStore;
    const tooltipPositionPreset = call.videoExpanded ? "top" : "bottom";

    return (
      <div className={styles["call-controls"]}>
        {call.isInProgress && (
          <>
            {call.remoteVideo.isPlayable &&
              !this.props.shouldCallDrawerBeHidden &&
              !call.videoExpanded && (
                <TooltipComponent
                  text={this.getVideoExpandTooltipText()}
                  maxWidth={`${TOOLTIP_WIDTH}px`}
                  style={"widget"}
                  positionPreset={tooltipPositionPreset}
                >
                  <WidgetControlCircle onClick={() => call.toggleVideoExpanded()}>
                    <i className={"icon-expand-video-icon"} />
                  </WidgetControlCircle>
                </TooltipComponent>
              )}
            <TooltipComponent
              text={this.getCameraTooltipText()}
              maxWidth={`${TOOLTIP_WIDTH}px`}
              style={"widget"}
              positionPreset={tooltipPositionPreset}
            >
              <WidgetControlCircle
                onClick={() => call.toggleCamera()}
                off={!call.localCamera.enabled}
              >
                <i className={"icon-camera-crossed"} />
              </WidgetControlCircle>
            </TooltipComponent>
            <TooltipComponent
              text={this.getMicTooltipText()}
              maxWidth={`${TOOLTIP_WIDTH}px`}
              style={"widget"}
              positionPreset={tooltipPositionPreset}
            >
              <WidgetControlCircle
                onClick={() => call.toggleMicrophone()}
                off={!call.localMicrophone.enabled}
              >
                <i className={"icon-crossed-mic"} />
              </WidgetControlCircle>
            </TooltipComponent>
          </>
        )}
        <TooltipComponent
          text={<L10n id="widget.call.disconnect" />}
          maxWidth={"100px"}
          style={"widget"}
          positionPreset={tooltipPositionPreset}
        >
          <WidgetControlCircle
            onClick={() => {
              call.hangup();
            }}
            red
          >
            <i className={"icon-end-call"} />
          </WidgetControlCircle>
        </TooltipComponent>
      </div>
    );
  }
}
